import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Homepage', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const services = [
    'Electrical Repairs',
    'Panel Upgrades',
    'Smart Home Wiring',
    'EV Charger Installation',
    'Emergency Service',
  ];

  return (
    <footer className="bg-secondary text-gray-300">
      {/* Upper Footer */}
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1: Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/9515c99ad4768c15e42e5804f92636ee.jpeg" 
                alt="Done to Power Up Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-white font-bold text-xl">Done to Power Up</span>
            </div>
            <p className="text-sm mb-6 leading-relaxed">
              Powering Your Home & Business Safely
            </p>
            <Link
              to="/contact"
              className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-medium text-sm hover:bg-primary/90 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Request Quote
            </Link>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-primary transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-sm hover:text-primary transition-colors duration-300 cursor-pointer"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <i className="ri-phone-line text-xl text-accent mt-1"></i>
                <div>
                  <p className="font-semibold mb-1">Phone</p>
                  <a href="tel:+16467501474" className="text-gray-300 hover:text-accent transition-colors cursor-pointer">
                    (646) 750-1474
                  </a>
                </div>
              </div>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-primary mt-0.5"></i>
                <a href="mailto:office@dtpuservices.com" className="hover:text-primary transition-colors duration-300 cursor-pointer">
                  office@dtpuservices.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-primary mt-0.5"></i>
                <span>2568 17th Street, Suit 101<br />Brooklyn, NY 11235</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-time-line text-primary mt-0.5"></i>
                <span>Mon-Fri: 8AM-6PM<br />Sat: 9AM-3PM</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="bg-[#151B26] py-6">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            {/* Copyright */}
            <p className="text-sm text-gray-400">
              © {currentYear} Done to Power Up. All rights reserved.
            </p>

            {/* Social Media */}
            <div className="flex items-center space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-500 text-gray-400 hover:border-primary hover:text-primary transition-all duration-300 cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-base"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-500 text-gray-400 hover:border-primary hover:text-primary transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-500 text-gray-400 hover:border-primary hover:text-primary transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-base"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-500 text-gray-400 hover:border-primary hover:text-primary transition-all duration-300 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-base"></i>
              </a>
            </div>

            {/* Links */}
            <div className="flex items-center space-x-6 text-sm">
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-primary transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
